"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Body/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _broadcast = require('shared/selectors/broadcast');
var _campaignState = require('web/screens/Broadcast/campaignState');
var _hooks = require('web/services/hooks');

var _RightSide = require('web/components/RightSide');
var _Controls = require('./Controls'); var _Controls2 = _interopRequireDefault(_Controls);
var _MessagesTable = require('./MessagesTable'); var _MessagesTable2 = _interopRequireDefault(_MessagesTable);
var _ProgressBar = require('./MessagesTable/ProgressBar'); var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
var _AddProgress = require('web/screens/Broadcast/Recipients/AddProgress'); var _AddProgress2 = _interopRequireDefault(_AddProgress);


















const CampaignPageBody = ({
  campaignKey,
  onPauseCampaign,
  onEditMessage,
  onAddExisting,
  onAddFromCsv,
  onRemovePatients,
  onQueueMessages,
  onDequeuePatients,
  isReviewingBlocked,
  onStopReviewing,
  activePanel = null,
  panel = null,
}) => {
  const isCampaignArchived = _hooks.useAppSelector.call(void 0, state => _broadcast.selectIsCampaignArchived.call(void 0, state, campaignKey))
  const hasStarted = _hooks.useAppSelector.call(void 0, state => {
    const campaign = _broadcast.selectCampaignByKey.call(void 0, state, campaignKey)
    return !!campaign && _campaignState.hasCampaignStarted.call(void 0, campaign)
  })

  return (
    _react2.default.createElement(_RightSide.RightSideBody, { className: "campaign-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
      , _react2.default.createElement(_Controls2.default, {
        campaignKey: campaignKey,
        isCampaignArchived: isCampaignArchived,
        onPauseCampaign: onPauseCampaign,
        onQueueMessages: onQueueMessages,
        onEditMessage: onEditMessage,
        onAddExisting: onAddExisting,
        onAddFromCsv: onAddFromCsv,
        activePanel: activePanel, __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}
      )
      ,  panel
        ? (
            _react2.default.createElement(_react2.default.Fragment, null
              , _react2.default.createElement(_AddProgress2.default, { campaignKey: campaignKey, onAddFromCsv: onAddFromCsv, __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}} )
              ,  hasStarted && _react2.default.createElement(_ProgressBar2.default, { campaignKey: campaignKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}} ) 
              , _react2.default.createElement('div', { className: "campaign-body--panel", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}},  panel )
            )
          )
        : (
            _react2.default.createElement(_react2.default.Fragment, null
              , _react2.default.createElement(_MessagesTable2.default, {
                campaignKey: campaignKey,
                onAddExisting: onAddExisting,
                onAddFromCsv: onAddFromCsv,
                onRemovePatients: onRemovePatients,
                onDequeuePatients: onDequeuePatients,
                isReviewingBlocked: isReviewingBlocked,
                onStopReviewing: onStopReviewing, __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
              )
            )
          )
      
    )
  )
}

exports. default = _react.memo.call(void 0, CampaignPageBody)
